module.exports = __webpack_public_path__ + "img/calendar.df077226.png";